import { render, staticRenderFns } from "./BidsOffersScreenMobile.vue?vue&type=template&id=3c0cbf40&scoped=true"
import script from "./BidsOffersScreenMobile.vue?vue&type=script&lang=js"
export * from "./BidsOffersScreenMobile.vue?vue&type=script&lang=js"
import style0 from "./BidsOffersScreenMobile.vue?vue&type=style&index=0&id=3c0cbf40&prod&scoped=true&lang=css"
import style1 from "./BidsOffersScreenMobile.vue?vue&type=style&index=1&id=3c0cbf40&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0cbf40",
  null
  
)

export default component.exports